var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('loading-screen',{attrs:{"content":_vm.loadingScreenContent}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }